import { useCallback } from 'react';
import { useAuthStore, toUser } from '../store/authStore';
import { authApi } from '../services/api';

/**
 * Auth actions. checkAuth asks the server who is signed in (the httpOnly
 * cookie travels automatically); logout clears the server session and the
 * local state.
 */
export function useAuth() {
  const setUser = useAuthStore((s) => s.setUser);
  const setLoading = useAuthStore((s) => s.setLoading);
  const clear = useAuthStore((s) => s.logout);

  const checkAuth = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await authApi.me();
      setUser(toUser(data.user));
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [setUser, setLoading]);

  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } catch {
      // The local session is cleared either way.
    }
    clear();
  }, [clear]);

  return { checkAuth, logout };
}
